export const DYNAMIC_CLIENT_DYNAMICS_CATMAN_KPIS = [
    'nb_cardholders_destination_competitor',
    'cardholder_sales_amount_destination_competitor',
    'cardholder_sales_amount_destination_competitor_with_promo',
    'cardholder_sales_amount_destination_competitor_without_promo',
    'cardholder_sales_quantity_destination_competitor',
    'cardholder_sales_quantity_destination_competitor_with_promo',
    'cardholder_sales_quantity_destination_competitor_without_promo',
    'brand_competitor_desc_anonymized'
];
export const DYNAMIC_CLIENT_DYNAMICS_KPI_DISPLAY_NAME = [
    'dynamic_client_nb_cardholders_destination_competitor',
    'dynamic_client_cardholder_sales_amount_destination_competitor',
    'dynamic_client_cardholder_sales_amount_destination_competitor_with_promo',
    'dynamic_client_cardholder_sales_amount_destination_competitor_without_promo',
    'dynamic_client_cardholder_sales_quantity_destination_competitor',
    'dynamic_client_cardholder_sales_quantity_destination_competitor_with_promo',
    'dynamic_client_cardholder_sales_quantity_destination_competitor_without_promo',
    'dynamic_client_brand_competitor_desc_anonymized'
];
export const DYNAMIC_CLIENT_DYNAMICS_KPI_MAPPING = {
    dynamic_client_nb_cardholders_destination_competitor: 'nb_cardholders_destination_competitor',
    dynamic_client_cardholder_sales_amount_destination_competitor: 'cardholder_sales_amount_destination_competitor',
    dynamic_client_cardholder_sales_amount_destination_competitor_with_promo: 'cardholder_sales_amount_destination_competitor_with_promo',
    dynamic_client_cardholder_sales_amount_destination_competitor_without_promo: 'cardholder_sales_amount_destination_competitor_without_promo',
    dynamic_client_cardholder_sales_quantity_destination_competitor: 'cardholder_sales_quantity_destination_competitor',
    dynamic_client_cardholder_sales_quantity_destination_competitor_with_promo: 'cardholder_sales_quantity_destination_competitor_with_promo',
    dynamic_client_cardholder_sales_quantity_destination_competitor_without_promo: 'cardholder_sales_quantity_destination_competitor_without_promo',
    dynamic_client_brand_competitor_desc_anonymized: 'brand_competitor_desc_anonymized'
};
//# sourceMappingURL=dynamicClientDynamics.kpis.js.map